/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreExternalCostResponseDto } from '../models/core-external-cost-response-dto';
import { externalCostsControllerCreate } from '../fn/external-costs/external-costs-controller-create';
import { ExternalCostsControllerCreate$Params } from '../fn/external-costs/external-costs-controller-create';
import { externalCostsControllerDelete } from '../fn/external-costs/external-costs-controller-delete';
import { ExternalCostsControllerDelete$Params } from '../fn/external-costs/external-costs-controller-delete';
import { externalCostsControllerFindAll } from '../fn/external-costs/external-costs-controller-find-all';
import { ExternalCostsControllerFindAll$Params } from '../fn/external-costs/external-costs-controller-find-all';
import { externalCostsControllerFindById } from '../fn/external-costs/external-costs-controller-find-by-id';
import { ExternalCostsControllerFindById$Params } from '../fn/external-costs/external-costs-controller-find-by-id';
import { externalCostsControllerFindByProjectId } from '../fn/external-costs/external-costs-controller-find-by-project-id';
import { ExternalCostsControllerFindByProjectId$Params } from '../fn/external-costs/external-costs-controller-find-by-project-id';
import { externalCostsControllerFindBySubtaskId } from '../fn/external-costs/external-costs-controller-find-by-subtask-id';
import { ExternalCostsControllerFindBySubtaskId$Params } from '../fn/external-costs/external-costs-controller-find-by-subtask-id';
import { externalCostsControllerFindByTaskId } from '../fn/external-costs/external-costs-controller-find-by-task-id';
import { ExternalCostsControllerFindByTaskId$Params } from '../fn/external-costs/external-costs-controller-find-by-task-id';
import { externalCostsControllerFindByUserId } from '../fn/external-costs/external-costs-controller-find-by-user-id';
import { ExternalCostsControllerFindByUserId$Params } from '../fn/external-costs/external-costs-controller-find-by-user-id';
import { externalCostsControllerUpdate } from '../fn/external-costs/external-costs-controller-update';
import { ExternalCostsControllerUpdate$Params } from '../fn/external-costs/external-costs-controller-update';

@Injectable({ providedIn: 'root' })
export class CoreExternalCostsService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `externalCostsControllerFindAll()` */
  static readonly ExternalCostsControllerFindAllPath = '/o2-core/external-costs/{tenant}';

  /**
   * Get all external costs for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindAll$Response(params: ExternalCostsControllerFindAll$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>> {
    const obs = externalCostsControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all external costs for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindAll(params: ExternalCostsControllerFindAll$Params, context?: HttpContext): Observable<Array<CoreExternalCostResponseDto>> {
    const resp = this.externalCostsControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>): Array<CoreExternalCostResponseDto> => r.body)
    );
  }

  /** Path part for operation `externalCostsControllerCreate()` */
  static readonly ExternalCostsControllerCreatePath = '/o2-core/external-costs/{tenant}';

  /**
   * Create a new external cost entry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  externalCostsControllerCreate$Response(params: ExternalCostsControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreExternalCostResponseDto>> {
    const obs = externalCostsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new external cost entry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  externalCostsControllerCreate(params: ExternalCostsControllerCreate$Params, context?: HttpContext): Observable<CoreExternalCostResponseDto> {
    const resp = this.externalCostsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreExternalCostResponseDto>): CoreExternalCostResponseDto => r.body)
    );
  }

  /** Path part for operation `externalCostsControllerFindById()` */
  static readonly ExternalCostsControllerFindByIdPath = '/o2-core/external-costs/{tenant}/id/{id}';

  /**
   * Get an external cost by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindById$Response(params: ExternalCostsControllerFindById$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreExternalCostResponseDto>> {
    const obs = externalCostsControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an external cost by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindById(params: ExternalCostsControllerFindById$Params, context?: HttpContext): Observable<CoreExternalCostResponseDto> {
    const resp = this.externalCostsControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreExternalCostResponseDto>): CoreExternalCostResponseDto => r.body)
    );
  }

  /** Path part for operation `externalCostsControllerDelete()` */
  static readonly ExternalCostsControllerDeletePath = '/o2-core/external-costs/{tenant}/id/{id}';

  /**
   * Delete an external cost.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerDelete$Response(params: ExternalCostsControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreExternalCostResponseDto>> {
    const obs = externalCostsControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete an external cost.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerDelete(params: ExternalCostsControllerDelete$Params, context?: HttpContext): Observable<CoreExternalCostResponseDto> {
    const resp = this.externalCostsControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreExternalCostResponseDto>): CoreExternalCostResponseDto => r.body)
    );
  }

  /** Path part for operation `externalCostsControllerUpdate()` */
  static readonly ExternalCostsControllerUpdatePath = '/o2-core/external-costs/{tenant}/id/{id}';

  /**
   * Update an external cost.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  externalCostsControllerUpdate$Response(params: ExternalCostsControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreExternalCostResponseDto>> {
    const obs = externalCostsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an external cost.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  externalCostsControllerUpdate(params: ExternalCostsControllerUpdate$Params, context?: HttpContext): Observable<CoreExternalCostResponseDto> {
    const resp = this.externalCostsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreExternalCostResponseDto>): CoreExternalCostResponseDto => r.body)
    );
  }

  /** Path part for operation `externalCostsControllerFindBySubtaskId()` */
  static readonly ExternalCostsControllerFindBySubtaskIdPath = '/o2-core/external-costs/{tenant}/subtask/{subtaskId}';

  /**
   * Get external costs for a specific subtask.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerFindBySubtaskId()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindBySubtaskId$Response(params: ExternalCostsControllerFindBySubtaskId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>> {
    const obs = externalCostsControllerFindBySubtaskId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get external costs for a specific subtask.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerFindBySubtaskId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindBySubtaskId(params: ExternalCostsControllerFindBySubtaskId$Params, context?: HttpContext): Observable<Array<CoreExternalCostResponseDto>> {
    const resp = this.externalCostsControllerFindBySubtaskId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>): Array<CoreExternalCostResponseDto> => r.body)
    );
  }

  /** Path part for operation `externalCostsControllerFindByProjectId()` */
  static readonly ExternalCostsControllerFindByProjectIdPath = '/o2-core/external-costs/{tenant}/project/{projectId}';

  /**
   * Get external costs for a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindByProjectId$Response(params: ExternalCostsControllerFindByProjectId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>> {
    const obs = externalCostsControllerFindByProjectId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get external costs for a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindByProjectId(params: ExternalCostsControllerFindByProjectId$Params, context?: HttpContext): Observable<Array<CoreExternalCostResponseDto>> {
    const resp = this.externalCostsControllerFindByProjectId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>): Array<CoreExternalCostResponseDto> => r.body)
    );
  }

  /** Path part for operation `externalCostsControllerFindByUserId()` */
  static readonly ExternalCostsControllerFindByUserIdPath = '/o2-core/external-costs/{tenant}/user/{userId}';

  /**
   * Get external costs for a specific user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindByUserId$Response(params: ExternalCostsControllerFindByUserId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>> {
    const obs = externalCostsControllerFindByUserId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get external costs for a specific user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindByUserId(params: ExternalCostsControllerFindByUserId$Params, context?: HttpContext): Observable<Array<CoreExternalCostResponseDto>> {
    const resp = this.externalCostsControllerFindByUserId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>): Array<CoreExternalCostResponseDto> => r.body)
    );
  }

  /** Path part for operation `externalCostsControllerFindByTaskId()` */
  static readonly ExternalCostsControllerFindByTaskIdPath = '/o2-core/external-costs/{tenant}/task/{taskId}';

  /**
   * Get external costs for a specific task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `externalCostsControllerFindByTaskId()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindByTaskId$Response(params: ExternalCostsControllerFindByTaskId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>> {
    const obs = externalCostsControllerFindByTaskId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get external costs for a specific task.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `externalCostsControllerFindByTaskId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  externalCostsControllerFindByTaskId(params: ExternalCostsControllerFindByTaskId$Params, context?: HttpContext): Observable<Array<CoreExternalCostResponseDto>> {
    const resp = this.externalCostsControllerFindByTaskId$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>): Array<CoreExternalCostResponseDto> => r.body)
    );
  }

}
